import * as React from "react";
import { PersonalPortfolioTypesArray, PersonalPortfolioTypesMap } from "../../Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../NewBusinessWizard/Components/SharedComponents";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SearchInput } from "../../../../../../Shared/SearchInput/SearchInput";
import { Table } from "../../../../../../Shared/Table/Table";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { CustomerNameFuzzySearchClient } from "../../../../../../../Wrap/Api/Customer/CustomerNameFuzzySearch";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InvestorType } from "../../../../../../../Wrap/Constants/Enums/Domain/InvestorType";
import { ClientAcountHelper } from "../../../NewBusinessWizard/Resource/ClientAccountHelper";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { QuoteAndApplyBaseModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/QuoteAndApplyBaseModel";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { Gender } from "../../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { InstructionStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";

interface IPPSectionProps extends IProcessComponentProps {
    ClientAccount?: ClientAccount;
    isQuote: boolean;
    data: QuoteAndApplyBaseModel;
}

interface IPPSectionState {
    customeChildren: JSX.Element;
    showLightBox: boolean;
    hideResult: boolean;
}

export class PPSection extends ProcessComponent<IPPSectionProps, IPPSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            customeChildren: null,
            showLightBox: false,
            hideResult: false,
        };
    }
    selectableInvestorTypes(): InvestorType[] {
        const { data, ClientAccount } = this.props;
        const maxGiasHit = ClientAcountHelper.MaxGiaCountHit(ClientAccount);
        const anyProductNotSupportJoint = data.SelectedProducts.some(
            (x) => SubAccountTypeHelper.productEligibleForJoint(x.SubAccountType) == false
        );
        if (maxGiasHit) {
            return [InvestorType.Joint];
        }
        if (anyProductNotSupportJoint) {
            return [InvestorType.Single];
        }
        return PersonalPortfolioTypesArray;
    }
    public render(): JSX.Element {
        const { data } = this.props;
        const { ClientDetails } = data;
        const productIndex = data.SelectedProducts.findIndex(
            (e) => e.SubAccountType == SubAccountType.InvestmentAccount
        );
        const Product = data.SelectedProducts[productIndex];

        return (
            <>
                {SectionHeader("Personal Portfolio options")}
                {TrueFalseRadio(
                    "Will your client be taking regular withdrawals?",
                    "IsAddRegularWithdrawalSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    {
                        cssWrapper: "radio-group rg-inline rg-150 mb-16",
                        disabled:
                            data.Status == InstructionStatus.Complete || data.Status == InstructionStatus.Cancelled,
                    }
                )}
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                    label="Account type"
                    selected={data.IsJointAccount ? InvestorType.Joint : InvestorType.Single}
                    options={this.selectableInvestorTypes()}
                    getText={(v) => {
                        return PersonalPortfolioTypesMap[v];
                    }}
                    onChange={(v) => {
                        this.onProductChange({ InvestorTypeType: v }, Product, productIndex);
                    }}
                    required="Please choose Personal Portfolio type"
                    disabled={data.Status == InstructionStatus.Complete || data.Status == InstructionStatus.Cancelled}
                />
                {Product.InvestorTypeType == InvestorType.Joint &&
                    !data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa) &&
                    !data.SecondClientDetails &&
                    this.accountDetailRender()}
                {Product.InvestorTypeType == InvestorType.Joint &&
                    data.SecondClientDetails &&
                    this.accountHolderRender(ClientDetails, data.SecondClientDetails)}

                {this.state.showLightBox && (
                    <Lightbox
                        show={this.state.showLightBox}
                        title={"Warning"}
                        onClose={() => this.setState({ showLightBox: false })}
                        type={LightboxType.Modal}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>Two account holders cannot be the same customer.</p>
                        <button className="btn primary" onClick={() => this.setState({ showLightBox: false })}>
                            OK
                        </button>
                    </Lightbox>
                )}

                <hr className="mb-26" />
            </>
        );
    }

    private onProductChange(changes, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        for (const key in changes) {
            _product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = _product;
        this.props.onChange({ SelectedProducts: data });
    }

    private accountDetailRender() {
        const client = new CustomerNameFuzzySearchClient();
        return (
            <>
                <h3>Joint account details</h3>
                <SearchInput
                    apiClient={(v) => {
                        return client.get(v, this.props.data.AdviserHierarchyId.EntityId, RoleType.JointAccountHolder);
                    }}
                    onInputFocus={() => this.setHideSearchCustomerResult(false)}
                    minLength={3}
                    customeChildren={(data) => this.transformInputSearch(data)}
                    cssWrapper="mb-35"
                />
            </>
        );
    }

    private accountHolderRender(first: any, second: any) {
        const config1 = [
            {
                title: "Title",
                data: first.Title,
            },
            {
                title: "Name",
                data: first.FirstName + " " + first.LastName,
            },
            {
                title: "Gender",
                data: first.Gender == Gender.Female ? "Female" : "Male",
            },
            {
                title: "Date of birth",
                data: JsonDateParser.getFormatDate(first.DateOfBirth, "dd/MM/yyyy"),
            },
        ];
        const config2 = [
            {
                title: "Title",
                data: second.Title,
            },
            {
                title: "Name",
                data: `${second.FirstName} ${second.LastName}`,
            },
            {
                title: "Gender",
                data: second.Gender == Gender.Female ? "Female" : "Male",
            },
            {
                title: "Date of birth",
                data: JsonDateParser.getFormatDate(second.DateOfBirth, "dd/MM/yyyy"),
            },
        ];
        return (
            <>
                <h3>Joint account holder</h3>
                <div className="row">
                    <div className="col-6">
                        <h3>Client 1</h3>
                        <Typography type="common" config={config1}></Typography>
                    </div>

                    <div className="col-6">
                        <h3>Client 2</h3>
                        <Typography type="common" config={config2}></Typography>
                        <button className="remove-button" onClick={() => this.removeClient()}>
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">remove client</span>
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private transformInputSearch(data: any) {
        if (data) {
            const customeChildren = (
                <Table
                    data={data}
                    col={[
                        {
                            title: "Client",
                            key: "Name",
                            render: (data, row, index) => {
                                return <span>{row.FirstName + " " + row.LastName}</span>;
                            },
                        },
                        {
                            title: "Date of birth",
                            key: "DateOfBirth",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDateString(new Date(data), "dd MM yyyy", true);
                            },
                        },
                        {
                            title: "Assigned adviser",
                            key: "OwnerAdviserId",
                        },
                        {
                            title: "",
                            key: "",
                            render: (data, row, index) => {
                                return (
                                    <button className="secondary-add-button" onClick={() => this.addClient(row)}>
                                        <span className="text">+ add client</span>
                                    </button>
                                );
                            },
                        },
                    ]}
                    showEmptyMsg={true}
                />
            );
            return this.state.hideResult ? null : customeChildren;
        }
    }

    private addClient(row: any) {
        const SecondClientDetails = row;
        const { ClientDetails } = this.props.data;
        if (ClientDetails?.ActorId == SecondClientDetails?.ActorId) {
            this.setState({ showLightBox: true });
        } else {
            this.props.onChange({ SecondClientDetails: SecondClientDetails });
            this.setHideSearchCustomerResult();
        }
    }

    private removeClient() {
        this.props.onChange({ SecondClientDetails: null });
    }
    private setHideSearchCustomerResult(hideResult = true) {
        this.setState({ hideResult });
    }
}
